import { render, staticRenderFns } from "./operate-log.vue?vue&type=template&id=a2a3496c&"
import script from "./operate-log.vue?vue&type=script&lang=js&"
export * from "./operate-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports